import styled from 'styled-components';

export const Container = styled.section`
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  width: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  overflow: hidden;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: var(--color-grey-99);
`;
